import { abyssColors } from '@/theme/colors';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

export const CardContainer = styled(Box)(() => ({
  backgroundColor: '#ffffff',
  border: `0.1rem solid ${abyssColors.primary[200]}`,
  borderRadius: '1.1rem',
  padding: '2rem 2.4rem',
  display: 'flex',
  flexDirection: 'column',
  gap: '0.8rem',
  minWidth: 280,
  flexShrink: 0,
}));

export const TitleRow = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.8rem',
  color: abyssColors.primary[700],
  '& svg': {
    width: '2rem',
    height: '2rem',
  },
}));

export const Title = styled(Typography)(() => ({
  fontWeight: 400,
  fontSize: '1.2rem',
  lineHeight: '2rem',
  color: abyssColors.primary[500],
}));

export const Value = styled(Typography)(() => ({
  fontWeight: 500,
  fontSize: '3.2rem',
  lineHeight: '4rem',
  color: abyssColors.primary[500],
}));

export const Label = styled(Typography)(() => ({
  fontWeight: 400,
  fontSize: '1.4rem',
  lineHeight: '2rem',
  color: abyssColors.primary[400],
}));

export const ValueRow = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
}));

export const SubtitleBlock = styled(Box)(() => ({
  marginTop: 6,
}));

export const SubtitleSide = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  marginRight: 8,
  marginLeft: 8,
}));

export const SubtitleInline = styled(Box)(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  whiteSpace: 'nowrap',
}));

export const SubtitleIcon = styled(Box)(() => ({
  display: 'inline-flex',
  alignItems: 'center',
}));

export const SubtitleText = styled(Typography)(() => ({
  fontSize: '1.2rem',
  opacity: 0.8,
  color: abyssColors.primary[400],
}));
